import { Component, Inject } from '@angular/core';
import Icons from '../../enums/icons.enum';
import { Clipboard} from '@angular/cdk/clipboard';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from '../../services/auth.service';
import { DialogModeType } from './dialog-message-type.enum';
import LoginPrompt from '../../enums/login-prompt.enum';
import { AuthenticationEvent } from '../../models/authentication-event.model';
import { UserService } from '../../services/user.service';
import { SiteModel } from '../../models/sites.model';
import { ErrorDialogData } from '../../models/error-dialog-data.model';
import { MessageCode, UserMessage } from './user-message';
import { ToastMessageService } from '../../services/toast-message.service';
import AuthType from '../../enums/auth.type.enum';

@Component({
    selector: 'fss-portal-error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrls: ['./error-dialog.component.scss'],
    standalone: false
})
export class ErrorDialogComponent {
  public Icons = Icons;
  public message: string;
  public messageCode: MessageCode;
  public description: string;
  public showLogin = false;
  public error: any;
  public disableClose: boolean;
  public mode: DialogModeType;
  public icons = Icons;
  public allowsGuest: boolean = false;
  public learnMoreMessage: string;
  public copyClipText: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ErrorDialogData,
              private authServices: AuthService,
              private userService: UserService,
              private toastService: ToastMessageService,
              private clipboard: Clipboard) {

    this.message = this.data.message;
    this.messageCode = this.data.messageCode;
    this.showLogin = this.data.showLoginBtn;
    this.disableClose = this.data.disableClose;
    this.mode = this.data.mode;
    this.error = this.data.error;
    this.description = this.data.description;
    this.learnMoreMessage = UserMessage.learnMoreMsg + (this.error ? ' and technical details' : '') + '.';
    const siteGuid = this.authServices.getSiteGuid();
    if(siteGuid){
      const site:SiteModel = this.userService.getSite(siteGuid);
      this.allowsGuest = site && site.guestAllowed;
    }
    this.copyClipText =  this.message ? 'Message: ' + this.message + '\n\n' : '' ;
    this.copyClipText +=  this.messageCode ? 'Error Code: ' + this.messageCode + '\n\n': '';
    this.copyClipText +=  this.error ? 'Technical Details: ' + this.error  : '' ;
  }

  public doLogin(){
    this.authServices.initiateAuthentication(new AuthenticationEvent(LoginPrompt.LOGIN, AuthType.LOGIN, this.authServices.getSiteGuid(), 'error-dialog-login'));
  }
  public copyToClipboard() {
    this.clipboard.copy(this.copyClipText);
    this.toastService.show(DialogModeType.INFO, UserMessage.copiedToClipboard, false);
  }
  public continueAsGuest() {
    this.authServices.initiateAuthentication(new AuthenticationEvent(LoginPrompt.NONE, AuthType.LOGIN, this.authServices.getSiteGuid(), 'error-dialog-guest'));
  }
}
